<template>
    <div id="priority-list-datatable">
        <DataTable :value="priorities" :totalRecords="priorities.length" responsiveLayout="scroll"
            @row-click="onRowClick">
            <Column field="adminTitle" :header="$t('ficheBu.priority_list.columns.1')">
                <template #body="slotProps">
                    {{ slotProps.data.adminTitle }}
                </template>
            </Column>
            <Column field="lastHistory" :header="$t('ficheBu.priority_list.columns.2')">
                <template #body="slotProps">
                    <div class="flex flex-wrap gap-2"
                        :set="lastHistory = getLastHistory(slotProps.data.priorityHistory)">
                        <span v-if="lastHistory">
                            <as-title :title="formatDate(lastHistory.date) + ' - ' + lastHistory['title' + locale]"
                                :size="6"></as-title><br />
                            {{ lastHistory['content' + locale] }}
                        </span>
                    </div>
                </template>
            </Column>
            <Column field="nbHistories" :header="$t('ficheBu.priority_list.columns.3')">
                <template #body="slotProps">
                    <div class="flex flex-wrap gap-2">
                        {{ slotProps.data.priorityHistory.length }}
                    </div>
                </template>
            </Column>
            <Column style="width:100px">
                <template #body="slotProps">
                    <Button class="p-button-danger" icon="pi pi-trash" iconPos="right"
                        @click="deletePriority(slotProps.data.id)" />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script>
import AsTitle from "../Elements/AsTitle.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import moment from "moment";

export default {
    name: "PriorityList",
    components: {
        AsTitle,
        DataTable,
        Column,
        Button,
    },
    props: {
        priorities: Array,
    },
    emits: ["onRowClick", "onDelete"],
    computed: {
        locale() {
            const locale = this.$i18n.locale
            const firstLetter = locale.charAt(0).toUpperCase()
            const rest = locale.slice(1).toLowerCase()
            return firstLetter + rest;
        },
    },
    data() {
        return {};
    },
    methods: {
        onRowClick(priority) {
            this.$emit("onRowClick", priority.data);
        },
        deletePriority(priorityId) {
            this.$emit("onDelete", priorityId);
        },
        getLastHistory(histories) {
            return histories.sort((a, b) =>
                moment(b.date).toDate().getTime() - moment(a.date).toDate().getTime()
            )[0] || null
        },
        formatDate(date) {
            return moment(date).format("MM/YYYY");
        },
    },
};
</script>
<style lang="scss">
#priority-list-datatable {
    .p-datatable-wrapper {
        .p-datatable-tbody tr {
            cursor: pointer;
            transition: background-color 0.2s ease-in-out;

            &:hover {
                background-color: #f5f5f5;
            }
        }
    }
}
</style>